import { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Layout from "./layouts/Layout";
import LayoutAllInclusive from "./layouts/LayoutAllInclusive";
import LayoutAllExclusive from "./layouts/LayoutAllExclusive";
import LayoutCouple from "./layouts/LayoutCouple";
import LayoutFamily from "./layouts/LayoutFamily";
import LayoutBeach from "./layouts/LayoutBeach";
import LayoutLastminute from "./layouts/LayoutLastminute";
import LayoutLuxury from "./layouts/LayoutLuxury";
import LayoutHoneymoon from "./layouts/LayoutHoneymoon";
import LayoutLandingPage from "./layouts/LayoutLandingPage";
import LayoutResults from "./layouts/LayoutResults";
import LayoutCountry from "./layouts/LayoutCountry";
import LayoutLMDeals from "./layouts/LayoutLMDeals";
import LayoutDest from "./layouts/LayoutDest";
import LayoutSocialBooking from './layouts/LayoutSocialBooking';


import { useAppContext } from "./contexts/AppContext";
import Home from "./pages/Home";
import Loader from './components/LoaderComponent';
import LayoutSignIn from './layouts/LayoutSignIn';
// import SearchPage from './pages/SearchPage';
import Search from './pages/Search';
import AddHotel from './pages/AddHotel';
import EditHotel from './pages/EditHotel';
import ForgotPassword from './pages/ForgotPassword';
import MyHotels from './pages/MyHotels';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import SignIn from './pages/SignIn';
import CustomRouteAreaDestination from './components/CustomRoutes/CustomRouteAreaDestination';
import CustomRouteCountry from './components/CustomRoutes/CustomRouteCountry';
import CustomRouteDetail from './components/CustomRoutes/CustomRouteDetail';
import CustomRouteTopdestination from './components/CustomRoutes/CustomRouteTopDestination';
import AddBlog from './pages/AddBlog';
import BlogDetail from './pages/BlogDetail';
import Blogs from './pages/Blogs';
import Dealsupto1000 from './pages/Budgets/Dealsupto1000';
import Dealsupto2000 from './pages/Budgets/Dealsupto2000';
import Dealsupto300 from './pages/Budgets/Dealsupto300';
import Dealsupto500 from './pages/Budgets/Dealsupto500';
import MyBlogs from './pages/MyBlogs';
import MyBookings from './pages/MyBookings';
import PageAllInclusive from './pages/PageAllInclusive';
import PageAllExclusive from './pages/PageAllExclusive';
import PageBeach from './pages/PageBeach';
import PageCouple from './pages/PageCouple';
import PageFamily from './pages/PageFamily';
import PageHoneymoon from './pages/PageHoneymoon';
import PageLastminute from './pages/PageLastminute';
import PageLuxury from './pages/PageLuxury';
import RegisterPopup from './pages/RegisterPopup';
import SignInPopup from './pages/SignInPopup';
//import CustomRouteFlashDetail from './components/CustomRoutes/CustomRouteFlashDetail';
import NotFound from './pages/404';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import DestinationsPage from './pages/DestinationsPage';
import EditBlog from './pages/EditBlog';
import LastMinuteDealsPage from './pages/LastMinuteDealsPage';
import Resort from './pages/ResortPage';
import TermsPage from './pages/TermsPage';
import ThankYou from './pages/Thankyou';
import Ebooks from './pages/Ebooks';
import Sitemap from './pages/Sitemap';
import Pricing from './pages/Pricing';
import BookingDetails from './components/BookingDetails';
import BookingFlow from './pages/BookingFlow';
import HaloPromise from './pages/HaloPromise';
import CancellationPolicy from './pages/CancellationPolicy';
import RefundPolicy from './pages/RefundPolicy';
import SocialBookNow from './pages/SocialBookNow';
import Success from './pages/Success';
import RegionSearch from './pages/RegionSerchResultPage';


// const Register = React.lazy(() => import("./pages/Register"));
// const SignIn = React.lazy(() => import("./pages/SignIn"));
// const ForgotPassword = React.lazy(() => import("./pages/ForgotPassword"));
// const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
// const AddHotel = React.lazy(() => import("./pages/AddHotel"));
// const MyHotels = React.lazy(() => import("./pages/MyHotels"));
// const EditHotel = React.lazy(() => import("./pages/EditHotel"));
// const Search = React.lazy(() => import("./pages/Search"));
//const Detail = React.lazy(() => import("./pages/Detail"));
// const Booking = React.lazy(() => import("./pages/Booking"));
//const MyBookings = React.lazy(() => import("./pages/MyBookings"));
// const Home = React.lazy(() => import("./pages/Home"));
// const PageAllInclusive = React.lazy(() => import("./pages/PageAllInclusive"));
// const PageCouple = React.lazy(() => import("./pages/PageCouple"));
// const PageFamily = React.lazy(() => import("./pages/PageFamily"));
// const PageBeach = React.lazy(() => import("./pages/PageBeach"));
// const PageLastminute = React.lazy(() => import("./pages/PageLastminute"));
// const PageLuxury = React.lazy(() => import("./pages/PageLuxury"));
// const PageHoneymoon = React.lazy(() => import("./pages/PageHoneymoon"));
// const Dealsupto300 = React.lazy(() => import("./pages/Budgets/Dealsupto300"));
// const Dealsupto500 = React.lazy(() => import("./pages/Budgets/Dealsupto500"));
// const Dealsupto1000 = React.lazy(() => import("./pages/Budgets/Dealsupto1000"));
// const Dealsupto2000 = React.lazy(() => import("./pages/Budgets/Dealsupto2000"));
// const SignInPopup = React.lazy(() => import("./pages/SignInPopup"));
// const RegisterPopup = React.lazy(() => import("./pages/RegisterPopup"));
// const Blogs = React.lazy(() => import("./pages/Blogs"));
// const AddBlog = React.lazy(() => import('./pages/AddBlog'));
// const MyBlogs = React.lazy(() => import('./pages/MyBlogs'));
// const BlogDetail = React.lazy(() => import('./pages/BlogDetail'));
// const CustomRouteDetail = React.lazy(() => import('./components/CustomRoutes/CustomRouteDetail'));
// const CustomRouteCountry = React.lazy(() => import('./components/CustomRoutes/CustomRouteCountry'));
// const CustomRouteTopdestination = React.lazy(() => import('./components/CustomRoutes/CustomRouteTopDestination'));
// const CustomRouteAreaDestination = React.lazy(() => import('./components/CustomRoutes/CustomRouteAreaDestination'));
// const BlogLandingPage = React.lazy (()=> import("./pages/BlogLandingPage")) ;
// const DestinationsPage = React.lazy (()=> import("./pages/DestinationsPage")) ;
// const ContactUs = React.lazy (()=> import("./pages/ContactUs"));
// const AboutUs = React.lazy (()=> import("./pages/AboutUs"));
//const CountryPage = React.lazy (()=> import("./pages/CountryPage"));
//const TopDestinationPage = React.lazy (()=> import("./pages/TopDestinationPage"));
//const AreaDestinationPage = React.lazy (()=> import('./pages/AreaDestinationPage'));
// const TermsPage = React.lazy (()=> import('./pages/TermsPage'));
// const BritishTravelAwardsPage = React.lazy (()=> import('./pages/BritishTravelAwards'));
// const LastMinuteDealsPage = React.lazy (()=> import('./pages/LastMinuteDealsPage'));
// const ThankYou = React.lazy (()=> import('./pages/Thankyou'));
// const NotFound = React.lazy (()=> import('./pages/404'));
// const EditBlog = React.lazy (()=> import('./pages/EditBlog'));
// const CompetitionTerm = React.lazy (()=> import('./pages/CompetitionTerm'));
// const Resort = React.lazy (() => import('./pages/ResortPage'));
// const CustomRouteFlashDetail = React.lazy (() => import('./components/CustomRoutes/CustomRouteFlashDetail'));

const App = () => {
  const { isLoggedIn } = useAppContext();

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/search" element={<Layout><Search /></Layout>} />
          <Route path="/search-results" element={<Layout><RegionSearch /></Layout>} />
          <Route path="/resort/*" element={<LayoutLandingPage><CustomRouteDetail /></LayoutLandingPage>} />
          {/* <Route path="/last-minute-deals/*" element={<LayoutLandingPage><CustomRouteFlashDetail /></LayoutLandingPage>} /> */}
          <Route path="/resort/" element={<LayoutLandingPage><Resort /></LayoutLandingPage>} />
          <Route path="/register" element={<LayoutSignIn><Register /></LayoutSignIn>} />
          <Route path="/register-pop-up" element={<RegisterPopup />} />
          <Route path="/destinations" element={<LayoutDest><DestinationsPage /></LayoutDest>}/>
          <Route path="/couple-holidays" element={<LayoutCouple><PageCouple /></LayoutCouple>} />
          <Route path="/all-inclusive-holidays" element={<LayoutAllInclusive><PageAllInclusive /></LayoutAllInclusive>} />
          <Route path="/all-exclusive-holidays" element={<LayoutAllExclusive><PageAllExclusive /></LayoutAllExclusive>} />
          <Route path="/family-holidays" element={<LayoutFamily><PageFamily /></LayoutFamily>} />
          <Route path="/last-minute-holidays" element={<LayoutLastminute><PageLastminute /></LayoutLastminute>} />
          <Route path="/beach-holidays" element={<LayoutBeach><PageBeach /></LayoutBeach>} />
          <Route path="/honeymoon-holidays" element={<LayoutHoneymoon><PageHoneymoon /></LayoutHoneymoon>} />
          <Route path="/luxury-holidays" element={<LayoutLuxury><PageLuxury /></LayoutLuxury>} />
          <Route path="/sign-in" element={<LayoutSignIn><SignIn /></LayoutSignIn>} />
          <Route path="/pricing" element={<LayoutSignIn><Pricing /></LayoutSignIn>} />
          <Route path="/forgot-password" element={<LayoutSignIn><ForgotPassword /></LayoutSignIn>} />
          <Route path="/reset-password/:resetToken" element={<LayoutSignIn><ResetPassword /></LayoutSignIn>} />
          <Route path="/sign-in-form" element={<SignInPopup />} />
          <Route path="/add-blog" element={<LayoutSignIn><AddBlog /></LayoutSignIn>} />
          <Route path="/edit-blog/:slug" element={<Layout><EditBlog /></Layout>} />
          <Route path="/my-blogs" element={<LayoutSignIn><MyBlogs /></LayoutSignIn>} />
          <Route path="/blogs/:slug" element={<Layout> <BlogDetail/> </Layout>}/>
          <Route path="/deals-upto-300" element={<Layout><Dealsupto300 /></Layout>} />
          <Route path="/deals-upto-500" element={<Layout><Dealsupto500 /></Layout>} />
          <Route path="/deals-upto-1000" element={<Layout><Dealsupto1000 /></Layout>} />
          <Route path="/deals-upto-2000" element={<Layout><Dealsupto2000 /></Layout>} />
          <Route path="/blogs" element={<Layout><Blogs /></Layout>} />
          <Route path='/contact-us' element={<LayoutDest><ContactUs /></LayoutDest>}  />
          <Route path='/about-us' element={<AboutUs/>} />
          <Route path="/destinations/*" element={<LayoutCountry><CustomRouteCountry /></LayoutCountry>} />
          <Route path="/destinations/:countrySlug/:destinationSlug" element={<LayoutCountry><CustomRouteTopdestination /></LayoutCountry>} />
          <Route path="/destinations/:country/:topDestination/:areaDestinationSlug" element={<LayoutCountry><CustomRouteAreaDestination /></LayoutCountry>} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/last-minute-deals" element={<LayoutLMDeals><LastMinuteDealsPage /></LayoutLMDeals>} />
          <Route path='/thank-you' element={<ThankYou />} />
          <Route path="/ebooks" element={<Layout><Ebooks /></Layout>} />
          <Route path="/sitemap" element={<LayoutSignIn><Sitemap /></LayoutSignIn>} />
          <Route path="/halo-promise" element={<LayoutSignIn><HaloPromise /></LayoutSignIn>} />
          <Route path="/cancellation-policy" element={<LayoutSignIn><CancellationPolicy /></LayoutSignIn>} />
          <Route path="/refund-policy" element={<LayoutSignIn><RefundPolicy /></LayoutSignIn>} />
          {/* <Route path='/SearchPage' element={<SearchPage/>}/> */}
          <Route path='/404' element={<NotFound/>} />
          <Route path="/add-hotel" element={<LayoutSignIn><AddHotel /></LayoutSignIn>} />
          <Route path="/my-hotels" element={<LayoutSignIn><MyHotels /></LayoutSignIn>} />
          <Route path="/edit-hotel/:slug" element={<LayoutResults><EditHotel /></LayoutResults>} />
          <Route path="/booking-details/:partner_order_id" element={<LayoutSignIn><BookingDetails /></LayoutSignIn>} />
          {/* <Route path="/booking-form" element={<LayoutSignIn><BookingDetailForm /></LayoutSignIn>} /> */}
          <Route path='/booking/:book_hash' element={<LayoutSignIn><BookingFlow/> </LayoutSignIn>} />
          <Route path="/holiday-to-sri-lanka" element={<LayoutSocialBooking><SocialBookNow /></LayoutSocialBooking>} />
          <Route path="/success" element={<LayoutSocialBooking><Success /></LayoutSocialBooking>} />

          {isLoggedIn && (
            <>
              {/* <Route path="/hotel/:hotelId/booking" element={<Layout><Booking /></Layout>} /> */}
              {/* <Route path="/add-hotel" element={<LayoutSignIn><AddHotel /></LayoutSignIn>} /> */}
              {/* <Route path="/edit-hotel/:slug" element={<LayoutResults><EditHotel /></LayoutResults>} /> */}
              {/* <Route path="/my-hotels" element={<LayoutSignIn><MyHotels /></LayoutSignIn>} /> */}
              <Route path="/my-bookings" element={<LayoutSignIn><MyBookings /></LayoutSignIn>} />
            </>
          )}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
